<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position:relative;">
      <span class="main-title">FOOD SUMMARY | &nbsp;</span>
      <span class="submain-title">Store orders</span>
      <download-excel
        :data="export_form_order_store"
        :fields="{
              'No':  'No' ,
              'Order code' : 'order_code' ,
              'Order ref.' : 'order_base_code' ,
              'Date time order' :  'order_time_start',
              'Note' : 'order_note' ,
              'Sales'  : 'summary'
           }"
        :name="'OrderStoreReport-' + ($route.params.storeid  == 0 ? 'All_store' : showName)  + '_'+$route.params.datetime_start+'_to_'+$route.params.datetime_end+'.xls'"
        style="position:absolute;top:0px;right:40px;"
      >
        <v-btn icon>
          <v-icon large color="black">print</v-icon>.xls
        </v-btn>
      </download-excel>
      <download-excel
        type="csv"
        :data="export_form_order_store"
        :fields="{
              'No':  'No' ,
              'Order code' : 'order_code' ,
              'Order ref.' : 'order_base_code' ,
              'Date time order' :  'order_time_start',
              'Note' : 'order_note' ,
              'Sales'  : 'summary'
           }"
        :name="'OrderStoreReport-' + ($route.params.storeid  == 0 ? 'All_store' : showName)  + '_'+$route.params.datetime_start+'_to_'+$route.params.datetime_end+'.csv'"
        style="position:absolute;top:0px;right:150px;"
      >
        <v-btn icon>
          <v-icon large color="black">print</v-icon>.csv
        </v-btn>
      </download-excel>
    </div>
    <v-card dark style="border-radius:10px;">
      <v-layout row justify-space-between class="pa-3">
        <v-flex xs1>
          <div
            class="pt-2 text-xs-center search-btn"
            @click="$router.push({path :'/weserve_admin_login/control/' + $store.state.backOffice.province + '/report/store_payment'})"
          >
            <v-icon large color="black">arrow_back</v-icon>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
    <storePaymentOrder />
  </div>
</template>

<script>
import { mapState } from "vuex";
import SerachStartEnd from "@/components/back-office/Report/SearchBar/SerachStartEnd";
import storePaymentOrder from "@/components/back-office/Report/StorePaymentOrderList";
export default {
  data() {
    return {};
  },
  components: {
    SerachStartEnd,
    storePaymentOrder
  },
  destroyed() {
    if (this.$route.name != "storePayment") {
      this.$store.commit("fetchStorePaymentReport/resetState");
    }
  },
  computed: {
    ...mapState({
      search_config: state => state.fetchStorePaymentReport.clone_config_path,
      export_form_order_store: state =>
        state.fetchStorePaymentReport.export_form_order_store,
      order_store_list: state => state.fetchStorePaymentReport.order_store_list,
      store_payment_list: state =>
        state.fetchStorePaymentReport.store_payment_list
    }),
    showName() {
      let name = "";
      for (let val of this.store_payment_list) {
        if (val.store_id == this.$route.params.storeid) {
          name = val.store_name;
          break;
        }
      }
      return name;
    }
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard"
      },
      {
        text: "Store payment",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/store_payment"
      },
      {
        text: "Store orders",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/store_payment_order"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}
</style>

